import { Button, Modal, Row } from "react-bootstrap";
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { MySelect } from "../../ui/controls/MySelect";
import { MyTextInput } from "../../ui/controls/MyTextInput";
import { MyDatePicker } from "../../ui/controls/MyDatePicker";
import { MyTextArea2 } from "../../ui/controls/MyTextArea2";
import { onlyIntegersDecimals } from "../../../helpers/numericFields";
import { useSelector, useDispatch } from 'react-redux';
import { addPaymentMasterSale } from "../../../store/slices/groupFiles/thunks";
import { getPaymentWayList } from "../../../store/slices/general/thunks";
import { MyFileInput } from "../../ui/controls/MyFileInput";
import { Image_Type } from "../../../const/Image"
import Swal from "sweetalert2";
import { useEffect, useState } from "react";

export const AddAdvancePayment = ({ masterSaleGroup, isOpen, setIsOpen }) => {
  const dispatch = useDispatch();
  const { paymentMethodList, paymentWayList } = useSelector((state) => state.general);
  const [rooms, setRooms] = useState([]);
  const [services, setServices] = useState([]);

  useEffect(() => {
    const items = [];
    for (const room of masterSaleGroup.rooms) {
      items.push({"value":room.id, "label": room.occupancy + " " + room.roomCategory + ", " + room.hotel})
    }
    setRooms(items)
  }, [masterSaleGroup.rooms]);

  useEffect(() => {
    const items = [];
    for (const service of masterSaleGroup.services) {
      items.push({"value":service.id, "label": service.service})
    }
    setServices(items)
  }, [masterSaleGroup.services]);

  return (
    <>
      <Modal
        size="xl"
        show={isOpen}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <Modal.Title >
            Agregar Anticipo De Grupo
          </Modal.Title>
          <Button
            onClick={() => setIsOpen(false)}
            className="btn-close"
            variant=""
          >
            x
          </Button>
        </Modal.Header>

        <Formik
          initialValues={{
            date: new Date(),
            amount: "",
            paymentMethod: undefined,
            paymentWay: undefined,            
            reference: "",
            notes: "",
            image: undefined,
            roomMasterSaleGroup: undefined,
            serviceMasterSaleGroup: undefined,
          }}
          onSubmit={(({ date, amount, paymentMethod, paymentWay, reference, notes, image2, roomMasterSaleGroup, 
            serviceMasterSaleGroup }, { resetForm, setErrors }) => {

            if (!date) {
              return setErrors({ "date": "Requerido" })
            }
            if (!paymentMethod) {
              return setErrors({ "paymentMethod": "Requerido" })
            }
            if (!paymentWay) {
              return setErrors({ "paymentWay": "Requerido" })
            }
            if(paymentMethod.label !== "EFECTIVO" && !image2){              
                return setErrors({ "image": "Requerido" })              
            }            

            let date2;
            if (date.year) {
              date2 = date.year + "-" + (date.monthIndex + 1) + "-" + date.day
            } else {
              date2 = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
            }

            const success = () => {
              resetForm();
              setIsOpen(false)
            }

            dispatch(addPaymentMasterSale(masterSaleGroup.id, date2, amount, paymentWay.value, reference, 
              image2, notes, roomMasterSaleGroup ? roomMasterSaleGroup.value : null, 
              serviceMasterSaleGroup ? serviceMasterSaleGroup.value : null, masterSaleGroup.idGroupFile, success));
          })}
          validationSchema={
            Yup.object({
              amount: Yup.string()
                .required("Requerido"),
            })
          }
        >

          {
            ({ setFieldValue }) => (
              <Form>
                <Modal.Body>
                  <Row>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MyDatePicker
                          label='Fecha de pago:*' name="date" mode='horizontal'
                          className="form-control fc-datepicker"
                          singleSelect="true"
                          placeholder="dd/mm/aaaa"
                          onChange={e => {
                            setFieldValue("date", e);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput label='Monto:*' name='amount' mode='horizontal'
                          onChange={(e) => {
                            if (!onlyIntegersDecimals(e)) {
                              return
                            }
                            setFieldValue("amount", e.target.value);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MySelect label='Metodo:*' name="paymentMethod" options={paymentMethodList} mode='horizontal'
                          singleSelect="true"
                          onChange={e => {
                            setFieldValue("paymentMethod", e);
                            setFieldValue("paymentWay", null);
                            dispatch(getPaymentWayList(e.value))
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MySelect label='Forma de pago:*' name="paymentWay" options={paymentWayList} mode='horizontal'
                          singleSelect="true"
                          onChange={e => {
                            setFieldValue("paymentWay", e);
                          }} />
                      </div>
                    </div>                    
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MyTextInput label='Referencia:' name='reference' mode='horizontal'
                          onChange={(e) => {
                            setFieldValue("reference", e.target.value);
                          }} />
                      </div>
                    </div>    
                    <div className="col-lg-6 col-md-12">
                      <MyFileInput label='Comprobante' name='image' mode='horizontal'
                        onChange={(e) => {
                          if (e.target.files[0]) {
                            if (Image_Type.indexOf(e.target.files[0].type) === -1) {
                              setFieldValue("image2", undefined)
                              return Swal.fire("Pagos", "Formato no valido", "error");
                            }
                            if (e.target.files[0].size > 2000000) {
                              setFieldValue("image2", undefined)
                              return Swal.fire("Pagos", "Solo se permiten imagenes de 2MB max", "error");
                            }
                            setFieldValue("image2", e.currentTarget.files[0])
                          }
                        }}
                      />
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MySelect label='Hospedaje:' name="roomMasterSaleGroup" options={rooms} mode='horizontal'
                          singleSelect="true"
                          onChange={e => {
                            setFieldValue("roomMasterSaleGroup", e);
                            setFieldValue("serviceMasterSaleGroup", null);
                          }} />
                      </div>
                    </div>  
                    <div className="col-lg-6 col-md-12">
                      <div className=" row mb-4">
                        <MySelect label='Servicio:' name="serviceMasterSaleGroup" options={services} mode='horizontal'
                          singleSelect="true"
                          onChange={e => {
                            setFieldValue("serviceMasterSaleGroup", e);
                            setFieldValue("roomMasterSaleGroup", null);
                          }} />
                      </div>
                    </div>                
                    <div className="col-lg-12 col-md-12">
                      <div className=" row mb-4">
                        <MyTextArea2 label='Notas:' name='notes' mode='horizontal' rows={4} />
                      </div>
                    </div>                    
                  </Row>
                  <div style={{ fontSize: 13 }}>* Dato obligatorio</div>
                </Modal.Body>

                <Modal.Footer>
                  <Button variant="primary" type="submit">
                    Guardar Informacion
                  </Button>
                </Modal.Footer>
              </Form>
            )
          }
        </Formik>


      </Modal>
    </>
  )
}
